import { Eye, EyeOff } from 'lucide-react';

const FONT_B = { fontFamily: "'Manrope', sans-serif" };

function FieldInput({ label, type = 'text', value, onChange, testId, required, placeholder }) {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1.5" style={FONT_B}>{label}</label>
      <input
        type={type} value={value} onChange={e => onChange(e.target.value)} required={required} placeholder={placeholder}
        className="w-full rounded-lg border border-gray-200 px-4 py-3 text-sm bg-white focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 outline-none transition-all"
        style={FONT_B} data-testid={testId}
      />
    </div>
  );
}

export function AdminSignupFields({ form, setForm }) {
  return (
    <>
      <div className="grid grid-cols-2 gap-3">
        <FieldInput label="First Name" value={form.first_name} onChange={v => setForm(p => ({ ...p, first_name: v }))} testId="auth-admin-fname" required />
        <FieldInput label="Last Name" value={form.last_name} onChange={v => setForm(p => ({ ...p, last_name: v }))} testId="auth-admin-lname" required />
      </div>
      <FieldInput
        label="Group Name"
        value={form.society_name}
        onChange={v => setForm(p => ({ ...p, society_name: v }))}
        testId="auth-admin-society"
        required
        placeholder="e.g. golf group, friend group, sports club, bar"
      />
    </>
  );
}

export function PlayerSignupFields({ form, setForm }) {
  return (
    <>
      <div className="grid grid-cols-2 gap-3">
        <FieldInput label="First Name" value={form.first_name} onChange={v => setForm(p => ({ ...p, first_name: v }))} testId="auth-player-fname" required />
        <FieldInput label="Last Name" value={form.last_name} onChange={v => setForm(p => ({ ...p, last_name: v }))} testId="auth-player-lname" required />
      </div>
      <FieldInput
        label="Display Name"
        value={form.display_name}
        onChange={v => setForm(p => ({ ...p, display_name: v }))}
        testId="auth-player-display"
        placeholder="How others see you on the leaderboard"
      />
    </>
  );
}

export function PasswordField({ label = 'Password', value, onChange, show, onToggleShow, testId, required, placeholder }) {
  return (
    <div>
      <div className="relative">
        <FieldInput
          label={label}
          type={show ? 'text' : 'password'}
          value={value}
          onChange={onChange}
          testId={testId}
          required={required}
          placeholder={placeholder}
        />
        <button
          type="button"
          onClick={onToggleShow}
          className="absolute right-3 top-[38px] text-gray-400 hover:text-gray-600"
          aria-label={show ? 'Hide password' : 'Show password'}
        >
          {show ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
        </button>
      </div>
    </div>
  );
}

export { FieldInput };
